module.exports = __webpack_public_path__ + "img/bg-img-news-and-announcements.8ab1ceb0.svg";